export default __webpack_public_path__ + "static/media/viber.bbddd5d0.svg";